// DOCUMENT READY:ANFANG ============================================================================================================
jQuery(document).ready(function ($) {

    const planerSlider = $(".planer-updates");
    planerSlider.slick({
        dots: true,
        arrows: false,
        infinite: false
    });

    // planerSlider.on('wheel', (function(e) {

    //     var slideCount = $(this)[0].slick["slideCount"];
    //     var currentIndex = $(this).slick("slickCurrentSlide");
    //     var totalSildeToShow =  $(this)[0].slick.options["slidesToShow"];
      
    //     if (e.originalEvent.deltaY < 0) {
      
    //       if (currentIndex == 0)
    //         return;
        
    //       e.preventDefault();
    //       $(this).slick('slickPrev');
      
    //     } else {
    //       if (slideCount - totalSildeToShow == currentIndex)
    //         return;
    //       e.preventDefault();
    //       $(this).slick('slickNext')
    //     }
    // }));

    var blocked = false;
    var blockTimeout = null;
    var prevDeltaY = 0;

    function mouseWheelHandler(e) {

        e.preventDefault();
        e.stopPropagation(); 

        var deltaY = e.originalEvent.deltaY;

        var slideCount = $(this)[0].slick["slideCount"];
        var currentIndex = $(this).slick("slickCurrentSlide");
        var totalSildeToShow =  $(this)[0].slick.options["slidesToShow"];

        clearTimeout(blockTimeout);
        blockTimeout = setTimeout(function(){
            blocked = false;
        }, 50);
        
        if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {
            blocked = true;
            prevDeltaY = deltaY;

            if (deltaY < 0) { 
                $(this).slick('slickPrev');
            } else {
                if (slideCount - totalSildeToShow == currentIndex)
                    return;
                $(this).slick('slickNext');
            }
        }
    }

    $(window).resize(function () {
        if ($(window).outerHeight() > 767) {
            planerSlider.on('wheel', mouseWheelHandler);
        }
    });

    if ($(window).outerHeight() > 767) {
        planerSlider.on('wheel', mouseWheelHandler);
    }

});
// DOCUMENT READY:ENDE============================================================================================================


// WEBPACK FOOTER //
// ./js/contentelements/tx-planer-updates.js